/**
 * The SDK exposes $chatwoot before its iframe is ready to receive messages.
 * Wait for the iframe, otherwise setUser can be lost during its initial load.
 */
export const whenChatwootReady = (
  callback: (chatwoot: ChatwootSdk) => void,
): (() => void) | undefined => {
  if (window.$chatwoot?.hasLoaded) {
    callback(window.$chatwoot);
    return undefined;
  }

  const onReady = () => {
    if (!window.$chatwoot?.hasLoaded) return;

    window.removeEventListener('chatwoot:ready', onReady);
    callback(window.$chatwoot);
  };

  window.addEventListener('chatwoot:ready', onReady);
  return () => window.removeEventListener('chatwoot:ready', onReady);
};
